import React from "react";

const MainContainer = ({ children }) => {
  return (
    <div>
      <div className="min-h-screen p-8 bg-[#F8FAFC] w-full">{children}</div>
    </div>
  );
};

export default MainContainer;
